module.exports = __webpack_public_path__ + "img/vc.2a9b1e94.svg";